{
    "AddCRMTitle": "CRM-integratie toevoegen",
    "ModififyCRMTitle": "CRM-integratie wijzigen",
    "CRMDetailsTitle": "Details",
    "CRMGeneralIDLabel": "ID",
    "CRMDetailsIDLabelPlaceholder": "[Automatisch toegewezen]",
    "CRMDetailsDescriptionLabel": "Beschrijving",
    "CRMValidationDescriptionLabel": "Beschrijving is vereist",
    "NAME": "CRMModal",
    "CRMScopeTitle": "Domein",
    "CRMConfigurationTitle": "Configuratie",
    "CRMConfigurationCRMTypeLabel": "CRM",
    "CRMConfigurationTypeNone": "Geen",
    "CRMConfigurationTab_Setting_Name": "Instellingsnaam",
    "CRMConfigurationTab_Value": "Waarde"
}